<template>
  <div id="modalAuditRefund" class="modal fade">
    <div class="modal-dialog modal-dialog-vertical-center modal-lg" role="document">
      <div class="modal-content bd-0 tx-14">
         <modal-loading :show="loading"></modal-loading> 
        <div class="modal-header pd-y-20 pd-x-25">
          <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">{{$t("mall.退款审核不通过")}}</h6>
          <button type="button" data-dismiss="modal" aria-label="Close" class="close">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body pd-25">
           	<div class="form-group row align-items-start pd-x-10 mg-x-0">
           		<span class=" tx-gray-900">{{$t("mall.审核备注：")}}</span>
           		<div class="col-md-6 d-flex align-items-center mg-l-0">
           			<textarea v-model="auditRemark" rows="3" name="remark" class="form-control form-control-sm tx-13" :placeholder="$t('mall.审核不通过时必须填写原因')"></textarea>
           		</div>
           	</div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary tx-11 tx-uppercase pd-y-12 pd-x-25 tx-mont tx-semibold" @click="save()">{{$t("mall.保存审核结果")}}</button>
          <button type="button" class="btn btn-secondary tx-11 tx-uppercase pd-y-12 pd-x-25 tx-mont tx-semibold" data-dismiss="modal">{{$t("mall.取消")}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["open","info"],
  data() {
    return {
    	loading:false,
    	auditRemark:"",
    }
  },
  created() {
  },
  updated() {
  },
  watch:{
  	open: function(){
  		this.loading = false;
		this.auditRemark = "";
  	},
  },
  methods: {
  	save(){
  		if(!this.auditRemark){
  			ShowTip(this.$t('mall.请填写审核备注'),"danger");
  			return;
  		}
  		let vm = this;
  		vm.loading = true;
  		let param = {
  			accountId: vm.info.id,
				remark: vm.auditRemark,
  		}
  		$.api_call("api.AccountDetail.closeByBuyer", param, r => {
	        if (r.ErrorCode == "9999") {
	          	$("#modalAuditRefund").modal("hide");
	          	ShowTip(this.$t('mall.审核退款完成'),"success");
	          	this.$parent.getList();
	        } else {
	        		vm.loading = false;
	          	ShowTip(r.Message, "danger");
	        }
  		});
  	}
  }
};
</script>
